import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { clientApi, authApi } from '../utils/api';
import '../i18n';

const C = {
  dark: '#05100a', dark2: '#0a1710', green: '#27AE60',
  gold: '#D4A843', red: '#e74c3c', borderW: 'rgba(255,255,255,0.08)',
};

function Card({ children, style }) {
  return (
    <div style={{ background: C.dark2, border: `1px solid ${C.borderW}`, borderRadius: 16, padding: '1.5rem', ...style }}>
      {children}
    </div>
  );
}

function Timer({ endTime }) {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    const calc = () => {
      const diff = Math.max(0, Math.floor((new Date(endTime) - Date.now()) / 1000));
      setRemaining(diff);
    };
    calc();
    const t = setInterval(calc, 1000);
    return () => clearInterval(t);
  }, [endTime]);

  const h = Math.floor(remaining / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = remaining % 60;
  const isOverdue = remaining === 0;

  return (
    <div style={{ textAlign: 'center', padding: '2rem', background: isOverdue ? 'rgba(231,76,60,0.08)' : 'rgba(39,174,96,0.06)', borderRadius: 16, border: `1px solid ${isOverdue ? 'rgba(231,76,60,0.2)' : 'rgba(39,174,96,0.2)'}` }}>
      <div style={{ fontSize: '.8rem', fontWeight: 700, letterSpacing: '.15em', textTransform: 'uppercase', color: isOverdue ? C.red : C.green, marginBottom: '.8rem' }}>
        {isOverdue ? '⚠️ Tempo scaduto' : '⏱ Tempo rimanente'}
      </div>
      {!isOverdue ? (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          {[{ val: h, label: 'ore' }, { val: m, label: 'min' }, { val: s, label: 'sec' }].map(t => (
            <div key={t.label} style={{ textAlign: 'center' }}>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '3rem', fontWeight: 700, color: '#fff', lineHeight: 1 }}>
                {String(t.val).padStart(2, '0')}
              </div>
              <div style={{ fontSize: '.7rem', color: 'rgba(255,255,255,0.35)', marginTop: '.3rem', textTransform: 'uppercase', letterSpacing: '.1em' }}>{t.label}</div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ color: C.red, fontSize: '1rem', fontWeight: 600 }}>
          Riconsegna la bici allo staff. Grazie!
        </div>
      )}
    </div>
  );
}

function LoginForm({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await authApi.login(email, password);
      localStorage.setItem('brf_token', res.data.token);
      onLogin(res.data.user);
    } catch(err) {
      setError(err.response?.data?.error || 'Credenziali non valide.');
    } finally { setLoading(false); }
  }

  return (
    <div style={{ minHeight: '100vh', background: C.dark, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-body)' }}>
      <Card style={{ width: 360, maxWidth: '90vw' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '.5rem' }}>🚲</div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '1.8rem', color: '#fff', marginBottom: '.3rem' }}>
            Area <span style={{ color: C.green }}>Cliente</span>
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.3)', fontSize: '.85rem' }}>Accedi per vedere le tue prenotazioni</p>
        </div>
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '.9rem' }}>
            <label style={{ display: 'block', fontSize: '.72rem', fontWeight: 600, letterSpacing: '.1em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)', marginBottom: '.4rem' }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="mario@email.com" required
              style={{ width: '100%', padding: '.75rem 1rem', background: 'rgba(255,255,255,0.05)', border: `1px solid ${C.borderW}`, borderRadius: 10, color: '#fff', fontFamily: 'var(--font-body)', fontSize: '.88rem', outline: 'none', boxSizing: 'border-box' }}/>
          </div>
          <div style={{ marginBottom: '1.2rem' }}>
            <label style={{ display: 'block', fontSize: '.72rem', fontWeight: 600, letterSpacing: '.1em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)', marginBottom: '.4rem' }}>Password</label>
            <div style={{ position: 'relative' }}>
  <input type={showPwd ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required
    style={{ width: '100%', padding: '.75rem 3rem .75rem 1rem', background: 'rgba(255,255,255,0.05)', border: `1px solid ${C.borderW}`, borderRadius: 10, color: '#fff', fontFamily: 'var(--font-body)', fontSize: '.88rem', outline: 'none', boxSizing: 'border-box' }}/>
  <button type="button" onClick={() => setShowPwd(p => !p)}
    style={{ position: 'absolute', right: '0.8rem', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.1rem', color: 'rgba(255,255,255,0.4)' }}>
    {showPwd ? '🙈' : '👁️'}
  </button>
</div>
          </div>
          {error && <div style={{ color: C.red, fontSize: '.82rem', marginBottom: '.8rem', textAlign: 'center' }}>{error}</div>}
          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '.9rem', background: C.green, border: 'none', borderRadius: 12, color: C.dark, fontWeight: 700, fontSize: '.95rem', cursor: 'pointer', fontFamily: 'var(--font-body)' }}>
            {loading ? '⏳ Accesso...' : '🔑 Accedi'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '.82rem', color: 'rgba(255,255,255,0.3)' }}>
          <a href="/" style={{ color: C.green, textDecoration: 'none' }}>← Torna al sito</a>
        </p>
      </Card>
    </div>
  );
}

export default function ClientArea() {
  const { t } = useTranslation();
  const [user, setUser] = useState(null);
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('brf_token');
    if (token) {
      authApi.me()
        .then(r => { setUser(r.data); return clientApi.dashboard(); })
        .then(r => setDashboard(r.data))
        .catch(() => localStorage.removeItem('brf_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  function handleLogin(u) {
    setUser(u);
    clientApi.dashboard().then(r => setDashboard(r.data)).catch(() => {});
  }

  function handleLogout() {
    localStorage.removeItem('brf_token');
    setUser(null);
    setDashboard(null);
  }

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: C.dark, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ color: C.green, fontSize: '2rem', animation: 'spin 1s linear infinite' }}>🚲</div>
      </div>
    );
  }

  if (!user) return <LoginForm onLogin={handleLogin}/>;

  const active = dashboard?.active_booking;
  const history = dashboard?.history || [];
  const statusColors = { confirmed: C.gold, active: C.green, completed: '#3498db', cancelled: C.red };

  return (
    <div style={{ minHeight: '100vh', background: C.dark, fontFamily: 'var(--font-body)', color: '#fff' }}>
      {/* NAV */}
      <nav style={{ background: 'rgba(5,16,10,0.97)', borderBottom: `1px solid ${C.borderW}`, padding: '1rem 2rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <a href="/" style={{ fontFamily: 'var(--font-display)', fontSize: '1.3rem', color: '#fff', textDecoration: 'none' }}>
          Bike Rent <span style={{ color: C.green }}>Florence</span>
        </a>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <span style={{ fontSize: '.85rem', color: 'rgba(255,255,255,0.5)' }}>👤 {dashboard?.user?.name || user.email}</span>
          <button onClick={handleLogout} style={{ background: 'rgba(231,76,60,0.1)', border: '1px solid rgba(231,76,60,0.2)', borderRadius: 8, padding: '.4rem .9rem', color: C.red, fontSize: '.8rem', cursor: 'pointer', fontFamily: 'var(--font-body)' }}>
            Esci
          </button>
        </div>
      </nav>

      <div style={{ maxWidth: 900, margin: '0 auto', padding: '2rem 1.5rem' }}>

        {/* Noleggio attivo */}
        {active ? (
          <Card style={{ marginBottom: '2rem', border: `1px solid rgba(39,174,96,0.2)` }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '.8rem', marginBottom: '1.5rem' }}>
              <span style={{ fontSize: '1.5rem' }}>🚲</span>
              <div>
                <h2 style={{ color: '#fff', fontSize: '1.1rem', fontWeight: 700 }}>Noleggio in corso</h2>
                <div style={{ fontSize: '.8rem', color: 'rgba(255,255,255,0.4)', marginTop: '.2rem' }}>Ref: {active.booking_ref}</div>
              </div>
              <span style={{ marginLeft: 'auto', background: 'rgba(39,174,96,0.1)', color: C.green, fontSize: '.75rem', fontWeight: 700, padding: '.3rem .8rem', borderRadius: 20, border: '1px solid rgba(39,174,96,0.25)' }}>
                {active.status === 'active' ? '🟢 ATTIVO' : '🟡 CONFERMATO'}
              </span>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '.8rem', marginBottom: '1.5rem' }}>
              {[
                { label: 'Data', val: new Date(active.date_start).toLocaleDateString('it') },
                { label: 'Durata', val: active.duration },
                { label: 'Bici', val: `${active.qty_classic > 0 ? `${active.qty_classic}× classica` : ''} ${active.qty_ebike > 0 ? `${active.qty_ebike}× e-bike` : ''}`.trim() },
              ].map(r => (
                <div key={r.label} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 10, padding: '.8rem', textAlign: 'center' }}>
                  <div style={{ fontSize: '.68rem', color: 'rgba(255,255,255,0.35)', textTransform: 'uppercase', letterSpacing: '.1em', marginBottom: '.3rem' }}>{r.label}</div>
                  <div style={{ fontWeight: 600, color: '#fff', fontSize: '.9rem' }}>{r.val}</div>
                </div>
              ))}
            </div>

            {active.status === 'active' && dashboard?.timer && (
              <Timer endTime={dashboard.timer.end_time}/>
            )}

            {active.status === 'confirmed' && (
              <div style={{ background: 'rgba(212,168,67,0.08)', border: '1px solid rgba(212,168,67,0.2)', borderRadius: 10, padding: '1rem', textAlign: 'center', color: 'rgba(255,255,255,0.6)', fontSize: '.88rem' }}>
                ⏳ La tua prenotazione è confermata. Presentati in Piazza Duomo all'orario stabilito!
              </div>
            )}
          </Card>
        ) : (
          <Card style={{ marginBottom: '2rem', textAlign: 'center', padding: '2.5rem' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚲</div>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', marginBottom: '.5rem' }}>Nessun noleggio attivo</h2>
            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '.9rem', marginBottom: '1.5rem' }}>Prenota la tua prossima avventura fiorentina!</p>
            <a href="/#prenota" style={{ background: C.green, color: C.dark, fontWeight: 700, padding: '.7rem 1.8rem', borderRadius: 100, textDecoration: 'none', fontSize: '.9rem' }}>
              🚲 Prenota ora
            </a>
          </Card>
        )}

        {/* Storico */}
        <Card>
          <h3 style={{ color: '#fff', fontSize: '1rem', fontWeight: 600, marginBottom: '1.2rem' }}>📋 Storico prenotazioni</h3>
          {history.length === 0 && (
            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '.9rem' }}>Nessuna prenotazione precedente.</p>
          )}
          {history.map(b => (
            <div key={b.booking_ref} style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '.8rem', background: 'rgba(255,255,255,0.03)', borderRadius: 10, marginBottom: '.5rem', border: `1px solid rgba(255,255,255,0.06)` }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem', marginBottom: '.2rem' }}>
                  <span style={{ fontWeight: 600, color: '#fff', fontSize: '.88rem' }}>{b.booking_ref}</span>
                  <span style={{ fontSize: '.7rem', fontWeight: 600, color: statusColors[b.status] || C.gray, background: `${statusColors[b.status] || C.gray}18`, padding: '.15rem .5rem', borderRadius: 4 }}>{b.status}</span>
                </div>
                <div style={{ fontSize: '.78rem', color: 'rgba(255,255,255,0.4)' }}>
                  {new Date(b.date_start).toLocaleDateString('it')} · {b.duration}
                  {b.qty_classic > 0 && ` · ${b.qty_classic}× classica`}
                  {b.qty_ebike > 0 && ` · ${b.qty_ebike}× e-bike`}
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ color: C.green, fontWeight: 700 }}>€{b.total}</div>
              </div>
              {b.status === 'completed' && (
                <a href={`/api/client/bookings/${b.booking_ref}/contract`} target="_blank" rel="noreferrer"
                  style={{ background: 'rgba(255,255,255,0.06)', border: `1px solid ${C.borderW}`, borderRadius: 8, padding: '.35rem .7rem', color: 'rgba(255,255,255,0.5)', fontSize: '.72rem', textDecoration: 'none', whiteSpace: 'nowrap' }}>
                  📄 Contratto
                </a>
              )}
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}
